import { defaultTo } from "lodash"
import { ClientListingModel } from ".";

export interface IRecentClientListingModel {
    userId: number
    clientId: number
    firstName: string
    lastName: string
    emailAddress: string
    cellPhone: string
    homePhone: string
    alternatePhone: string
    address: string
    address2: string
    isOkToSms: boolean
    city: string
    state: string
    fullName: string
    pgrMasterId: string
    palsNumber: string
    isPinned: boolean
    sort: number
    rowNumber: number
    lastVisitDate: string | undefined
    canCall: boolean
    canSMS: boolean
    isActive: boolean
}

export class RecentClientListingModel implements IRecentClientListingModel {
    userId: number
    clientId: number
    firstName: string
    lastName: string
    emailAddress: string
    cellPhone: string
    homePhone: string
    alternatePhone: string
    address: string
    address2: string
    isOkToSms: boolean
    city: string
    state: string
    fullName: string
    pgrMasterId: string
    palsNumber: string
    isPinned: boolean
    sort: number
    rowNumber: number
    lastVisitDate: string | undefined
    canCall: boolean
    canSMS: boolean
    isActive: boolean

    constructor(params: IRecentClientListingModel) {
        this.userId = defaultTo(params.userId, 0);
        this.clientId = defaultTo(params.clientId, 0);
        this.firstName = defaultTo(params.firstName, "");
        this.lastName = defaultTo(params.lastName, "");
        this.emailAddress = defaultTo(params.emailAddress, "");
        this.cellPhone = defaultTo(params.cellPhone, "");
        this.homePhone = defaultTo(params.homePhone, "");
        this.alternatePhone = defaultTo(params.alternatePhone, "");
        this.address = defaultTo(params.address, "");
        this.address2 = defaultTo(params.address2, "");
        this.isOkToSms = defaultTo(params.isOkToSms, false);
        this.city = defaultTo(params.city, "");
        this.state = defaultTo(params.state, "");
        this.fullName = defaultTo(params.fullName, "");
        this.pgrMasterId = defaultTo(params.pgrMasterId, "");
        this.palsNumber = defaultTo(params.palsNumber, "");
        this.isPinned = defaultTo(params.isPinned, false);
        this.sort = defaultTo(params.userId, 0);
        this.rowNumber = defaultTo(params.userId, 0);
        this.canCall = params.canCall;
        this.canSMS = params.canSMS;
        this.isActive = params.isActive;
    }

    toClientListingModel(): ClientListingModel {
        return new ClientListingModel({
            ClientId: this.clientId.toString(),
            FirstName: this.firstName,
            LastName: this.lastName,
            FullName: this.fullName,
            AlternatePetParentName: "",
            EmailAddress: this.emailAddress,
            HomePhone: this.homePhone,
            CellPhone: this.cellPhone,
            AlternatePhone: this.alternatePhone,
            Address: this.address,
            Address2: this.address2,
            City: this.city,
            State: this.state,
            LastVisitDate: this.lastVisitDate,
            CanCall: this.canCall,
            CanSMS: this.canSMS,
            IsActive: this.isActive
        })
    }
}
